/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Smart Sash Admin API
 * RESTful API for Smart Sash device management, user authentication, and system administration
 * OpenAPI spec version: 0.13.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetApiPortalMeNotificationsParams,
  PortalMarkAllReadDto,
  PortalMarkAllReadRequest,
  PortalNotificationDto,
  PortalNotificationFeedDto,
  PortalUnreadCountDto,
  ProblemDetails
} from '../../models';

import { customInstance } from '../../../http/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiPortalMeNotifications = (
    params?: GetApiPortalMeNotificationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalNotificationFeedDto>(
      {url: `/api/portal/me/notifications`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiPortalMeNotificationsInfiniteQueryKey = (params?: GetApiPortalMeNotificationsParams,) => {
    return [
    'infinite', `/api/portal/me/notifications`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiPortalMeNotificationsQueryKey = (params?: GetApiPortalMeNotificationsParams,) => {
    return [
    `/api/portal/me/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiPortalMeNotificationsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeNotifications>>>, TError = PortalNotificationFeedDto | ProblemDetails>(params?: GetApiPortalMeNotificationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeNotificationsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeNotifications>>> = ({ signal }) => getApiPortalMeNotifications(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeNotificationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeNotifications>>>
export type GetApiPortalMeNotificationsInfiniteQueryError = PortalNotificationFeedDto | ProblemDetails


export function useGetApiPortalMeNotificationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeNotifications>>>, TError = PortalNotificationFeedDto | ProblemDetails>(
 params: undefined |  GetApiPortalMeNotificationsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeNotifications>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeNotificationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeNotifications>>>, TError = PortalNotificationFeedDto | ProblemDetails>(
 params?: GetApiPortalMeNotificationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeNotifications>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeNotificationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeNotifications>>>, TError = PortalNotificationFeedDto | ProblemDetails>(
 params?: GetApiPortalMeNotificationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeNotificationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeNotifications>>>, TError = PortalNotificationFeedDto | ProblemDetails>(
 params?: GetApiPortalMeNotificationsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeNotificationsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiPortalMeNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof getApiPortalMeNotifications>>, TError = PortalNotificationFeedDto | ProblemDetails>(params?: GetApiPortalMeNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeNotifications>>> = ({ signal }) => getApiPortalMeNotifications(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeNotifications>>>
export type GetApiPortalMeNotificationsQueryError = PortalNotificationFeedDto | ProblemDetails


export function useGetApiPortalMeNotifications<TData = Awaited<ReturnType<typeof getApiPortalMeNotifications>>, TError = PortalNotificationFeedDto | ProblemDetails>(
 params: undefined |  GetApiPortalMeNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeNotifications>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeNotifications<TData = Awaited<ReturnType<typeof getApiPortalMeNotifications>>, TError = PortalNotificationFeedDto | ProblemDetails>(
 params?: GetApiPortalMeNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeNotifications>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeNotifications<TData = Awaited<ReturnType<typeof getApiPortalMeNotifications>>, TError = PortalNotificationFeedDto | ProblemDetails>(
 params?: GetApiPortalMeNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeNotifications<TData = Awaited<ReturnType<typeof getApiPortalMeNotifications>>, TError = PortalNotificationFeedDto | ProblemDetails>(
 params?: GetApiPortalMeNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiPortalMeNotificationsUnreadCount = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalUnreadCountDto>(
      {url: `/api/portal/me/notifications/unread-count`, method: 'GET', signal
    },
      options);
    }




export const getGetApiPortalMeNotificationsUnreadCountInfiniteQueryKey = () => {
    return [
    'infinite', `/api/portal/me/notifications/unread-count`
    ] as const;
    }

export const getGetApiPortalMeNotificationsUnreadCountQueryKey = () => {
    return [
    `/api/portal/me/notifications/unread-count`
    ] as const;
    }


export const getGetApiPortalMeNotificationsUnreadCountInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>>, TError = ProblemDetails>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeNotificationsUnreadCountInfiniteQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>> = ({ signal }) => getApiPortalMeNotificationsUnreadCount(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeNotificationsUnreadCountInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>>
export type GetApiPortalMeNotificationsUnreadCountInfiniteQueryError = ProblemDetails


export function useGetApiPortalMeNotificationsUnreadCountInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>>, TError = ProblemDetails>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeNotificationsUnreadCountInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeNotificationsUnreadCountInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeNotificationsUnreadCountInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeNotificationsUnreadCountInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiPortalMeNotificationsUnreadCountQueryOptions = <TData = Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPortalMeNotificationsUnreadCountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>> = ({ signal }) => getApiPortalMeNotificationsUnreadCount(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPortalMeNotificationsUnreadCountQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>>
export type GetApiPortalMeNotificationsUnreadCountQueryError = ProblemDetails


export function useGetApiPortalMeNotificationsUnreadCount<TData = Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeNotificationsUnreadCount<TData = Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPortalMeNotificationsUnreadCount<TData = Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiPortalMeNotificationsUnreadCount<TData = Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPortalMeNotificationsUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiPortalMeNotificationsUnreadCountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiPortalMeNotificationsIdRead = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalNotificationDto>(
      {url: `/api/portal/me/notifications/${id}/read`, method: 'POST', signal
    },
      options);
    }




export const getPostApiPortalMeNotificationsIdReadMutationOptions = <TError = ProblemDetails | PortalNotificationDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeNotificationsIdRead>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeNotificationsIdRead>>, TError,{id: string}, TContext> => {

const mutationKey = ['postApiPortalMeNotificationsIdRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPortalMeNotificationsIdRead>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postApiPortalMeNotificationsIdRead(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiPortalMeNotificationsIdReadMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPortalMeNotificationsIdRead>>>

    export type PostApiPortalMeNotificationsIdReadMutationError = ProblemDetails | PortalNotificationDto

    export const usePostApiPortalMeNotificationsIdRead = <TError = ProblemDetails | PortalNotificationDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeNotificationsIdRead>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiPortalMeNotificationsIdRead>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPostApiPortalMeNotificationsIdReadMutationOptions(options), queryClient);
    }
    export const postApiPortalMeNotificationsReadAll = (
    portalMarkAllReadRequest?: PortalMarkAllReadRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalMarkAllReadDto>(
      {url: `/api/portal/me/notifications/read-all`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: portalMarkAllReadRequest, signal
    },
      options);
    }




export const getPostApiPortalMeNotificationsReadAllMutationOptions = <TError = PortalMarkAllReadDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeNotificationsReadAll>>, TError,{data?: PortalMarkAllReadRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeNotificationsReadAll>>, TError,{data?: PortalMarkAllReadRequest}, TContext> => {

const mutationKey = ['postApiPortalMeNotificationsReadAll'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPortalMeNotificationsReadAll>>, {data?: PortalMarkAllReadRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiPortalMeNotificationsReadAll(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiPortalMeNotificationsReadAllMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPortalMeNotificationsReadAll>>>
    export type PostApiPortalMeNotificationsReadAllMutationBody = PortalMarkAllReadRequest | undefined
    export type PostApiPortalMeNotificationsReadAllMutationError = PortalMarkAllReadDto | ProblemDetails

    export const usePostApiPortalMeNotificationsReadAll = <TError = PortalMarkAllReadDto | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeNotificationsReadAll>>, TError,{data?: PortalMarkAllReadRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiPortalMeNotificationsReadAll>>,
        TError,
        {data?: PortalMarkAllReadRequest},
        TContext
      > => {
      return useMutation(getPostApiPortalMeNotificationsReadAllMutationOptions(options), queryClient);
    }
    export const postApiPortalMeNotificationsIdAcknowledge = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalNotificationFeedDto>(
      {url: `/api/portal/me/notifications/${id}/acknowledge`, method: 'POST', signal
    },
      options);
    }




export const getPostApiPortalMeNotificationsIdAcknowledgeMutationOptions = <TError = ProblemDetails | PortalNotificationFeedDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeNotificationsIdAcknowledge>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeNotificationsIdAcknowledge>>, TError,{id: string}, TContext> => {

const mutationKey = ['postApiPortalMeNotificationsIdAcknowledge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPortalMeNotificationsIdAcknowledge>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postApiPortalMeNotificationsIdAcknowledge(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiPortalMeNotificationsIdAcknowledgeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPortalMeNotificationsIdAcknowledge>>>

    export type PostApiPortalMeNotificationsIdAcknowledgeMutationError = ProblemDetails | PortalNotificationFeedDto

    export const usePostApiPortalMeNotificationsIdAcknowledge = <TError = ProblemDetails | PortalNotificationFeedDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeNotificationsIdAcknowledge>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiPortalMeNotificationsIdAcknowledge>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPostApiPortalMeNotificationsIdAcknowledgeMutationOptions(options), queryClient);
    }
    export const postApiPortalMeNotificationsIdDismiss = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PortalNotificationFeedDto>(
      {url: `/api/portal/me/notifications/${id}/dismiss`, method: 'POST', signal
    },
      options);
    }




export const getPostApiPortalMeNotificationsIdDismissMutationOptions = <TError = ProblemDetails | PortalNotificationFeedDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeNotificationsIdDismiss>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeNotificationsIdDismiss>>, TError,{id: string}, TContext> => {

const mutationKey = ['postApiPortalMeNotificationsIdDismiss'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPortalMeNotificationsIdDismiss>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postApiPortalMeNotificationsIdDismiss(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiPortalMeNotificationsIdDismissMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPortalMeNotificationsIdDismiss>>>

    export type PostApiPortalMeNotificationsIdDismissMutationError = ProblemDetails | PortalNotificationFeedDto

    export const usePostApiPortalMeNotificationsIdDismiss = <TError = ProblemDetails | PortalNotificationFeedDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPortalMeNotificationsIdDismiss>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiPortalMeNotificationsIdDismiss>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPostApiPortalMeNotificationsIdDismissMutationOptions(options), queryClient);
    }
